module.exports = __webpack_public_path__ + "static/media/customer-voice.8d4964ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/equinixIcon/customer-voice.svg
// module id = 1111
// module chunks = 49